<template>
  <v-card v-if="currentIngredientType">
    <v-card-title>
      <h2 class="card-title">
        {{ $t('base.edit_ingredient_type') }}
      </h2>
    </v-card-title>
    <v-card-content>
      <v-text-field
        :focus="true"
        :label="$t('base.type_ingredient_type_name')"
        v-model="currentIngredientType.name"
      />
    </v-card-content>
    <v-card-actions>
      <v-btn class="mr-2" @click="onUpdate" :loading="loading">
        {{ $t('base.save') }}
      </v-btn>
      <delete-btn @delete="onDelete" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'SettingsIngredientTypeModal',

  components: {
    DeleteBtn
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters('ingredienttypes', [
      'currentIngredientType'
    ])
  },

  methods: {
    ...mapActions('ingredienttypes', [
      'updateIngredientType',
      'deleteIngredientType'
    ]),

    async onUpdate () {
      this.loading = true

      const error = await this.updateIngredientType()

      this.loading = false

      if (!error) {
        this.$emit('update')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    },

    async onDelete () {
      await this.deleteIngredientType()
      this.$emit('remove')
    }
  }
}
</script>